var _effectorFileName = "/builds/gmini/front-ui-kit/src/Cover/Cover.tsx";
import * as React from 'react';
import { Wrapper, Text, TopOffset } from './Cover.styled';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const Cover = /*#__PURE__*/React.memo(({
  title,
  open,
  icon,
  textColor = '#353b60',
  pb
}) => open ? /*#__PURE__*/_jsxs(Wrapper, {
  pb: pb,
  children: [/*#__PURE__*/_jsx(TopOffset, {}), icon, /*#__PURE__*/_jsx(Text, {
    color: textColor,
    children: title
  })]
}) : null);
Cover.displayName = 'Cover';